import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);
axios.defaults.timeout = 600000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
let loading = () => {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
  });
}
let hide = () => {
  Toast.clear()
}

// 超时时间
// axios.defaults.withCredentials=true;
// http请求拦截器
axios.interceptors.request.use(config => {
  // console.log(config)
  
      // 修改 Content-Type
      // config.headers['Content-Type'] =
      //   'application/x-www-form-urlencoded';

      config.headers['openid'] = localStorage.getItem('openid');
      
  if (config.params && config.params.hideLoading) {
    hide()
    delete config.params['hideLoading']
  } else {
    loading()
  }

  return config
}, error => {
  hide()
  // Notify('请求失败，请检查网络');
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(data => {// 响应成功关闭loading
  hide()
  return data
}, error => {
  hide()
  // Notify('请求失败，请检查网络');
  Toast.fail('请求错误')
  return Promise.reject(error)
})

export default {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  fetchPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params)).then(res => {
        // console.log(params)
        console.log(qs)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
